// 2026-05-01 P2 fix: scope MutationObserver to <main> (or body fallback) instead of documentElement to cut site-wide DOM observation cost (P2 item #4).
(function () {
  if (window.__kicImageInit) return;
  window.__kicImageInit = true;
  var markLoaded = function (wrap) {
    if (!wrap || wrap.classList.contains('is-loaded')) return;
    wrap.classList.add('is-loaded');
  };
  var bindImg = function (img) {
    if (img.dataset.kicImgBound) return;
    img.dataset.kicImgBound = '1';
    var wrap = img.closest('.kic-img');
    if (!wrap) return;
    if (img.complete && img.naturalWidth > 0) {
      markLoaded(wrap);
      return;
    }
    var done = function () { markLoaded(wrap); };
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  };
  var forceLoad = function (img) {
    if (img.dataset.kicImgForced) return;
    img.dataset.kicImgForced = '1';
    if (img.getAttribute('loading') === 'lazy') {
      img.setAttribute('loading', 'eager');
    }
    if (img.complete && img.naturalWidth > 0) {
      markLoaded(img.closest('.kic-img'));
    }
  };
  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var img = entry.target;
            forceLoad(img);
            io.unobserve(img);
          }
        });
      }, { rootMargin: '300px 0px', threshold: 0.01 })
    : null;
  var scan = function (root) {
    var scope = root && root.querySelectorAll ? root : document;
    var imgs = scope.querySelectorAll('.kic-img__el');
    for (var i = 0; i < imgs.length; i++) {
      bindImg(imgs[i]);
      if (io && !imgs[i].dataset.kicImgForced) {
        io.observe(imgs[i]);
      }
    }
  };
  var onReady = function () { scan(document); };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
  window.addEventListener('load', onReady);
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.classList && n.classList.contains('kic-img__el')) {
            bindImg(n);
            if (io) io.observe(n);
          } else if (n.querySelectorAll) {
            scan(n);
          }
        }
      }
    });
    // P2 fix #4: prefer scoping to <main> / #MainContent to avoid firing on
    // header / footer / dialog / cart-drawer mutations that have no kic-img__el
    // descendants. Falls back to body if main not present (rare). Re-targeting
    // is one-shot — first run after DOMContentLoaded chooses the tightest root.
    function chooseObserveRoot() {
      return (
        document.querySelector('main') ||
        document.getElementById('MainContent') ||
        document.querySelector('[role="main"]') ||
        document.body ||
        document.documentElement
      );
    }
    var observeRoot = chooseObserveRoot();
    mo.observe(observeRoot, { childList: true, subtree: true });
    // If main wasn't ready yet, re-target once DOM is parsed.
    if (observeRoot === document.documentElement || observeRoot === document.body) {
      document.addEventListener('DOMContentLoaded', function () {
        var better = chooseObserveRoot();
        if (better && better !== observeRoot) {
          mo.disconnect();
          observeRoot = better;
          mo.observe(observeRoot, { childList: true, subtree: true });
        }
      }, { once: true });
    }
  }
  window.KicImage = { scan: scan };
})();
